import {Rating} from "../../common/Rating";

export const RatingFilter = ({config, onChange, value}) => {
    const ratings = [
        {label: 'Top Rated', val: 'top'},
        {label: '5 stars', val: 5},
        {label: '4 stars & up', val: 4},
        {label: '3 stars & up', val: 3},
        {label: '2 stars & up', val: 2},
        {label: '1 star & up', val: 1},
    ];

    return (
        <div className="space-y-1">
            {ratings.map((r, i) => {
                const isChecked = value === r.val;
                return (
                    <label key={i}
                           className="flex items-center gap-3 p-1 cursor-pointer hover:bg-base-50 rounded transition-colors group">
                        <input
                            type="checkbox"
                            className="checkbox checkbox-primary checkbox-sm rounded-md border-base-300"
                            checked={isChecked}
                            onChange={() => onChange(isChecked ? 0 : r.val)}
                        />
                        <div className="flex items-center gap-2">
                            {typeof r.val === 'number' && <Rating value={r.val} size="xs" readOnly/>}
                            <span
                                className={`text-sm font-medium ${isChecked ? 'pt-dark-blue' : 'text-base-content/70'} transition-colors`}>
                                {r.label}
                            </span>
                        </div>
                    </label>
                );
            })}
        </div>
    );
};